<template>
  <div
    class="tw-border tw-rounded-3xl tw-p-4 tw-pl-7 tw-gap-6 tw-flex tw-items-center tw-cursor-pointer tw-transition-colors"
    :class="[
      notification.seen ? '' : 'tw-bg-light',
      notification.flag === 0 ? 'tw-border-gray/40 hover:tw-border-secondary' : '',
      notification.flag === 10 ? 'tw-border-primary/40 hover:tw-border-primary' : '',
      notification.flag === 20 ? 'tw-border-permit-1/40 hover:tw-border-permit-1' : '',
      notification.flag === 30 ? 'tw-border-permit-5/40 hover:tw-border-permit-5' : '',
      notification.flag === 40 ? 'tw-border-permit-4/40 hover:tw-border-permit-4' : '',
      notification.flag === 50 ? 'tw-border-permit-3/40 hover:tw-border-permit-3' : '',
    ]"
    @click="openNotificationDetails(false)"
  >
    <div>
      <NotificationTypeIcon
        :type="notification.notification_type"
      />
    </div>
    <div class="tw-font-medium tw-text-dark dark:tw-text-dm-dark tw-capitalize tw-w-2/6 tw-flex-shrink-0 tw-tracking-wider">
      {{ notification.title }}
    </div>
    <div class="tw-relative tw-text-gray-dark dark:tw-text-dm-gray-dark tw-text-nowrap tw-overflow-hidden tw-tracking-normal tw-w-full">
      {{ notification.description }}
      <div
        class="tw-absolute tw-right-0 tw-top-0 tw-w-3 tw-h-full tw-bg-gradient-to-r tw-from-transparent"
        :class="[
          notification.seen ? 'tw-to-white' : 'tw-to-light',
        ]"
      />
    </div>
    <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-text-right tw-flex-1 tw-whitespace-nowrap tw-flex-shrink-0 tw-tracking-normal">
      {{ notification.date_created }}
    </div>
    <div class="tw-flex tw-gap-2">
      <i-button
        type="white"
        is-icon
        @click.stop="toggleIsSeen"
      >
        <icon-checkbox-sm v-if="notification.seen" />
        <icon-checkbox-empty-sm v-else />
      </i-button>
      <NotificationFlag
        :flag-value="notification.flag"
        @updateFlag="updateNotificationFlag"
      />
      <i-button
        type="white"
        is-icon
        :class="[
          openInNewTabPressed ? 'tw-text-primary' : '',
        ]"
        @click.stop="openNotificationDetails(true)"
      >
        <icon-open-in-new-tab />
      </i-button>
    </div>
  </div>
</template>

<script>
import NotificationFlag from '@/components/Notifications/NotificationFlag.vue';
import NotificationTypeIcon from '@/components/Notifications/NotificationTypeIcon.vue';

export default {
  name: 'NotificationsNotificationV2',
  components: { NotificationTypeIcon, NotificationFlag },
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openInNewTabPressed: false,
    };
  },
  methods: {
    openNotificationDetails(openInNewTab) {
      if(openInNewTab) {
        this.openInNewTabPressed = true;
        window.open(this.notification.link, '_blank');
      } else {
        this.$router.push(this.notification.link);
      }
      if (!this.notification.seen) {
        this.$store.dispatch('v2/shared/notifications/updateNotification', { notificationId: this.notification.id, payload: { seen: true } });
      }
    },
    toggleIsSeen() {
      this.$store.dispatch('v2/shared/notifications/updateNotification', { notificationId: this.notification.id, payload: { seen: !this.notification.seen } });
    },
    async updateNotificationFlag(flag) {
      await this.$store.dispatch('v2/shared/notifications/updateNotification', { notificationId: this.notification.id, payload: { flag } });
      this.$store.dispatch('v2/shared/notifications/loadUnseenCount');
      this.$emit('updateFlag');
    },
  },
};
</script>
